
import styled from "styled-components";

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .spinner{
    width: ${({size})=> size};
    height: ${({size})=> size};
  margin: auto;

  }

.spinner-inner {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid ${({bgColor})=> bgColor};
  border-top-color: ${({color})=> color};
  animation: spin .8s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`

const AbsoluteSpinner = ({size, color, bgColor="var(--color-main)", borderSize="3px"}) => {
    return (
      <Container size={size} color={color} bgColor={bgColor}>
        <div className="spinner">
            <div className="spinner-inner"></div>
        </div>
      </Container>
    );
  };


export default AbsoluteSpinner